import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { PasswordInput, Icon, toast, BackdropLoader } from '@livable/saas-react-components';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { Typography, TextField, Button, Grid, Alert
// Link
} from '@mui/material';
import { useStore } from 'src/stores';
import { isDeepEqual } from 'src/utils/objectCMP';
export const UrjanetLoginModalForm = observer(_ref => {
  var _findProviderAlreadyI, _propertyUtility$prov4, _propertyUtility$prov5, _findProviderAlreadyI2, _findProviderAlreadyI3, _findProviderAlreadyI4, _findProviderAlreadyI5, _findProviderAlreadyI6;
  let companyCredentials = _ref.companyCredentials,
    providerInfo = _ref.providerInfo,
    propertyId = _ref.propertyId,
    propertyUtility = _ref.propertyUtility,
    callbackTrigger = _ref.callbackTrigger,
    handleModalClose = _ref.handleModalClose,
    isEdit = _ref.isEdit;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const _useState = useState(companyCredentials),
    _useState2 = _slicedToArray(_useState, 2),
    internalCompanyCredentials = _useState2[0],
    setInternalCompanyCredentials = _useState2[1];
  const findProviderAlreadyInSync = () => {
    if (internalCompanyCredentials && internalCompanyCredentials !== null && internalCompanyCredentials !== void 0 && internalCompanyCredentials.length) {
      return internalCompanyCredentials.find(credential => {
        var _propertyUtility$prov;
        return (credential.livableProviderId === (providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.id) || credential.livableProviderId === (propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$prov = propertyUtility.provider) === null || _propertyUtility$prov === void 0 ? void 0 : _propertyUtility$prov.utilityProviderId)) && (credential === null || credential === void 0 ? void 0 : credential.propertyId) === propertyId;
      });
    } else if (companyCredentials && companyCredentials !== null && companyCredentials !== void 0 && companyCredentials.length) {
      return companyCredentials.find(credential => {
        var _propertyUtility$prov2;
        return (credential.livableProviderId === (providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.id) || credential.livableProviderId === (propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$prov2 = propertyUtility.provider) === null || _propertyUtility$prov2 === void 0 ? void 0 : _propertyUtility$prov2.utilityProviderId)) && (credential === null || credential === void 0 ? void 0 : credential.propertyId) === propertyId;
      });
    } else {
      return null;
    }
  };
  const isProcessing = !!findProviderAlreadyInSync();
  const fetchCompanyCredentials = () => {
    return store.urjanet.getCompanyCredentialsAsync.run({}).then(resp => {
      if (resp.isSuccessful) {
        if (!isDeepEqual(internalCompanyCredentials, resp.response)) {
          setInternalCompanyCredentials(null);
          setInternalCompanyCredentials(resp.response);
        }
        return resp.response;
      }
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const saveProviderToProperty = async function () {
    let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        propertyIdExt: undefined,
        providerInfoExt: undefined
      },
      propertyIdExt = _ref2.propertyIdExt,
      providerInfoExt = _ref2.providerInfoExt;
    const providerToSave = {
      propertyId: propertyIdExt || propertyId,
      utilityProviderId: (providerInfoExt === null || providerInfoExt === void 0 ? void 0 : providerInfoExt.id) || (providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.id)
    };
    await store.properties.addPropertyUtilityProviderAsync.run(providerToSave);
  };
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    username = _useState4[0],
    setUsername = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    password = _useState6[0],
    setPassword = _useState6[1];
  const processLogin = async event => {
    var _propertyUtility$prov3;
    event.stopPropagation();
    const credentialsSaveResp = await store.urjanet.saveCredentialsAsync.run({
      userName: username,
      password: password,
      livableProviderId: (propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$prov3 = propertyUtility.provider) === null || _propertyUtility$prov3 === void 0 ? void 0 : _propertyUtility$prov3.utilityProviderId) || (providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.id),
      propertyId: propertyId
    });
    if (credentialsSaveResp !== null && credentialsSaveResp !== void 0 && credentialsSaveResp.isSuccessful) {
      await fetchCompanyCredentials();
    }
  };
  const processCredentialUpdate = async event => {
    event.stopPropagation();
    const matchingCredential = findProviderAlreadyInSync();
    const credentialsSaveResp = await store.urjanet.updateCredentialsAsync.run({
      userName: username,
      password: password,
      urjanetCredentialId: matchingCredential.id
    });
    if (credentialsSaveResp !== null && credentialsSaveResp !== void 0 && credentialsSaveResp.isSuccessful) {
      toast('success', {
        body: [t('general.successfully_updated')]
      });
      await fetchCompanyCredentials();
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      callbackTrigger && callbackTrigger();
      handleModalClose();
    }
  };
  const isSaveButtonDisabled = () => {
    return !(username !== null && username !== void 0 && username.length && password !== null && password !== void 0 && password.length) || store.urjanet.saveCredentialsAsync.inProgress || store.urjanet.updateCredentialsAsync.inProgress;
  };
  useEffect(() => {
    fetchCompanyCredentials();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    severity: !!findProviderAlreadyInSync() ? 'info' : 'success',
    icon: false,
    size: "small",
    variant: "modal"
  }, (isEdit || !findProviderAlreadyInSync()) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('Your data is protected')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "Automated: We use software, not people, to pull your data.", /*#__PURE__*/React.createElement("br", null), "Secure: We encrypt all credentials at rest and in transit.")), !!findProviderAlreadyInSync() && ((_findProviderAlreadyI = findProviderAlreadyInSync()) === null || _findProviderAlreadyI === void 0 ? void 0 : _findProviderAlreadyI.status) === 'Pending' && /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "This could take up some time so feel free to close the modal. We will notify you when it's done so you could finish activation.")), (!findProviderAlreadyInSync() || isEdit && !!findProviderAlreadyInSync()) && /*#__PURE__*/React.createElement(React.Fragment, null, isEdit ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.label
  }, "Enter new credentials to your Urjanet account for ", propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$prov4 = propertyUtility.provider) === null || _propertyUtility$prov4 === void 0 ? void 0 : _propertyUtility$prov4.utilityProviderName, ' ', "provider in order to set up the auto-billing", ' ', propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/') || 'N/a', ".") : /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.label
  }, "Login to your Urjanet account for ", propertyUtility === null || propertyUtility === void 0 || (_propertyUtility$prov5 = propertyUtility.provider) === null || _propertyUtility$prov5 === void 0 ? void 0 : _propertyUtility$prov5.utilityProviderName, " provider in order to set up the auto-billing ", propertyUtility.utilityTypes.map(i => i.utilityTypeName).join('/') || 'N/a', "."), /*#__PURE__*/React.createElement("div", {
    className: classes.form
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    columnSpacing: 10,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "username",
    name: "emusernameail",
    label: t('Username'),
    variant: "outlined",
    type: "email",
    fullWidth: true,
    value: username,
    onChange: event => {
      setUsername(event.target.value);
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(PasswordInput, {
    label: t('general.password'),
    id: "password",
    variant: "outlined",
    name: "password",
    fullWidth: true,
    value: password,
    onChange: event => {
      setPassword(event.target.value);
    }
  }))))), !isEdit && !!findProviderAlreadyInSync() && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.status
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.statusIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.statusText
  }, t('add_new_property_flow.establishing_a_secure_connection'))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.status, " ")
  }, /*#__PURE__*/React.createElement("div", {
    // className={`${findProviderAlreadyInSync?.status === 'Pending' && classes.spinner} ${classes.statusIcon}`}
    className: "".concat(classes.statusIcon)
  }, ['Pending', 'Completed'].includes((_findProviderAlreadyI2 = findProviderAlreadyInSync()) === null || _findProviderAlreadyI2 === void 0 ? void 0 : _findProviderAlreadyI2.status) && /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.statusText
  }, t('add_new_property_flow.checking_credentials'))), /*#__PURE__*/React.createElement("div", {
    // className={`${classes.status}  ${findProviderAlreadyInSync?.status === 'Pending' && 'awaiting'} ${
    className: "".concat(classes.status, " ").concat(((_findProviderAlreadyI3 = findProviderAlreadyInSync()) === null || _findProviderAlreadyI3 === void 0 ? void 0 : _findProviderAlreadyI3.status) === 'Pending' && 'checking')
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.statusIcon, " ").concat(((_findProviderAlreadyI4 = findProviderAlreadyInSync()) === null || _findProviderAlreadyI4 === void 0 ? void 0 : _findProviderAlreadyI4.status) === 'Pending' && classes.spinner)
  }, ((_findProviderAlreadyI5 = findProviderAlreadyInSync()) === null || _findProviderAlreadyI5 === void 0 ? void 0 : _findProviderAlreadyI5.status) === 'Pending' && /*#__PURE__*/React.createElement(Icon, {
    type: "loader"
  }), ((_findProviderAlreadyI6 = findProviderAlreadyInSync()) === null || _findProviderAlreadyI6 === void 0 ? void 0 : _findProviderAlreadyI6.status) === 'Completed' && /*#__PURE__*/React.createElement(Icon, {
    type: "success"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.statusText
  }, t('add_new_property_flow.awaiting_confirmation')))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      callbackTrigger && callbackTrigger();
      handleModalClose();
    }
  }, t('general.close'))), !isProcessing && !isEdit && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: processLogin,
    disabled: isSaveButtonDisabled()
  }, t('add_new_property_flow.login')))), isEdit && /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    onClick: processCredentialUpdate,
    disabled: isSaveButtonDisabled()
  }, t('add_new_property_flow.save_and_close')))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.urjanet.saveCredentialsAsync.inProgress || store.urjanet.updateCredentialsAsync.inProgress
  }));
});